/* eslint-disable prettier/prettier */
import useEnvConfig from "./useEnvConfig";

export default function useFeatures() {
    const { env } = useEnvConfig();
    const { features } = env;
    return features;
}
